export default "__VITE_ASSET__DwrwR4EV__"